const presearch = document.querySelector('.js-presearch');
const filters = Array.from(document.getElementsByClassName('js-filter'));
const submitButton   = document.querySelector('.js-submit-filters');

if (presearch && filters) {
  for (const filterEl of filters) {
    const filterToggle = filterEl.querySelector('.filter__btn');
    const filterClose = filterEl.querySelector('.js-filter-close');
    const filterType = filterEl.dataset.filterType ? filterEl.dataset.filterType : '';
    const filterValueEl = filterEl.querySelector('.filter__value');
    const filterDefaultValue = filterValueEl.textContent;
    const filterRadiusEl = filterEl.querySelector('.filter__radius');
    const filterOptions = Array.from(filterEl.getElementsByClassName('filter__option'));
    const filterRadiusSlider = filterEl.querySelector('input[type="range"]');
    let filterValues = [];

    filterOptions.forEach((option) => {
      const input = option.querySelector('input');
      input.addEventListener('change', function (e) {

        if (filterType === 'location') {
          const optionRadius = filterEl.querySelector('.filter__option__radius--active');

          if (optionRadius) {
            optionRadius.classList.remove('filter__option__radius--active');
            optionRadius.textContent = '';
          }

          option.querySelector('.filter__option__radius').classList.add('filter__option__radius--active');
          option.querySelector('.filter__option__radius').textContent = `+${parseInt(filterRadiusSlider.value)} km`;
        }

        if (input.type === 'checkbox') {
          if(this.checked) {
            filterValues.push(option.querySelector('label').innerText);
          } else {
            filterValues = filterValues.filter((value) => !option.querySelector('label').innerText.includes(value));
          }
          filterValueEl.textContent = filterValues.length > 0 ? filterValues.join(', ') : filterDefaultValue;
        } else {
          if (this.checked) {
            const filterActiveOption = option.querySelector('label');
            filterTxt = filterActiveOption ? filterActiveOption.innerText : filterDefaultValue;
            filterValueEl.textContent = filterTxt;

            if (filterType === 'location') {
              const filterRadiusEl = filterEl.querySelector('.filter__radius');
              filterRadiusEl.classList.add('filter__radius--open');
            }
          }
        }
      });

      if (filterType === 'location') {
        option.querySelector('input').addEventListener('click', function (e) {
          filterRadiusSlider.addEventListener('input', handleRangeChange)
          filterRadiusEl.classList.add('filter__radius--open');
        });
      }
    });

    if (filterType === 'location') {
      const percentage = (parseInt(filterRadiusSlider.value) - parseInt(filterRadiusSlider.min)) * 100 /
        (parseInt(filterRadiusSlider.max) - parseInt(filterRadiusSlider.min));

      filterRadiusSlider.addEventListener('input', handleRangeChange)
      filterRadiusSlider.style.backgroundSize = `${percentage}% 100%`;

      filterRadiusSlider.addEventListener('input', debounce((e) => {
        const activeLocation = document.querySelector('input[name="location"]:checked');
        const optionRadius = activeLocation.parentElement.querySelector('.filter__option__radius');

        optionRadius.classList.add('filter__option__radius--active');
        optionRadius.textContent = `+${parseInt(filterRadiusSlider.value)} km`;
      }));

      const resetProximityLink = document.querySelector('.js-reset-proximity');
      resetProximityLink.addEventListener('click', function () {
        const activeLocation = document.querySelector('input[name="location"]:checked');
        const optionRadius = activeLocation.parentElement.querySelector('.filter__option__radius')
        filterRadiusEl.classList.remove('filter__radius--open');
        filterRadiusSlider.value = 1;
        filterRadiusSlider.style.backgroundSize = '0% 100%';
        filterRadiusEl.querySelector('.js-displayed-proximity').textContent = '1';

        if (optionRadius) {
          optionRadius.classList.remove('filter__option__radius--active');
          optionRadius.textContent = '';
        }
      });
    }

    filterToggle.addEventListener('click', function (e) {
      if (filterType === 'location') {
        if (filterRadiusEl && filterRadiusEl.classList.contains('filter__radius--open') && filterEl.classList.contains('filter--open')) {
          const activeLocation = document.querySelector('input[name="location"]:checked');
          const optionRadius = activeLocation.parentElement.querySelector('.filter__option__radius')

          filterRadiusEl.classList.remove('filter__radius--open');

          if (typeof filterRadiusSlider !== 'undefined' && parseInt(filterRadiusSlider.value) > 1) {
            optionRadius.classList.add('filter__option__radius--active');
            optionRadius.textContent = `+${parseInt(filterRadiusSlider.value)} km`;
          }
        }
      }

      if (document.querySelector('.filter--open') && !filterEl.classList.contains('filter--open')) {
        document.querySelector('.filter--open').classList.remove('filter--open');
      }
      filterEl.classList.toggle('filter--open');
    });

    document.addEventListener('click', (e) => {
      if (!filterEl.contains(e.target)) {
        filterEl.classList.remove('filter--open');

        if (filterRadiusEl) {
          filterRadiusEl.classList.remove('filter__radius--open');
        }
      }
    });

    if (filterClose) {
      filterClose.addEventListener('click', (e) => {
        filterEl.classList.remove('filter--open');

        if (filterType === 'location') {
          const activeLocation = document.querySelector('input[name="location"]:checked');
          const optionRadius = activeLocation.parentElement.querySelector('.filter__option__radius')
          filterRadiusEl.classList.remove('filter__radius--open');
          optionRadius.classList.add('filter__option__radius--active');
        }
      });
    }
  }
  const wishInputs = document.querySelectorAll('input[name="wish"]');
  const propertyTypeInputs = document.querySelectorAll('input[name="property_type"]');
  const neighborhoodInputs = document.querySelectorAll('input[name="neighborhood"]');
  const locationInputs = document.querySelectorAll('input[name="location"]');
  const proximityInput = document.querySelector('input#proximity');

  if (submitButton.dataset.selectedWish === '') {
    submitButton.addEventListener('click', preventClick);
  }

  if (wishInputs) {
    wishInputs.forEach((wishInput) => {
      wishInput.addEventListener('input', function () {
        editCtaUrl();
      });
    });
  }
  if (propertyTypeInputs) {
    propertyTypeInputs.forEach((propertyTypeInput) => {
      propertyTypeInput.addEventListener('input', function () {
        editCtaUrl();
      });
    });
  }
  if (neighborhoodInputs) {
    neighborhoodInputs.forEach((neighborhoodInput) => {
      neighborhoodInput.addEventListener('input', function () {
        editCtaUrl();
      });
    });
  }
  if (locationInputs) {
    locationInputs.forEach((locationInput) => {
      locationInput.addEventListener('input', function () {
        editCtaUrl();
      });
    });
  }
  if (proximityInput) {
    proximityInput.addEventListener('input', function () {
      editCtaUrl();
    });
  }
}

function editCtaUrl() {
  let submitButtonUrl;
  let submitButtonUrlNbParams;
  let propertyTypeSlug;
  const selectedWishes = document.querySelectorAll('input[name=wish]:checked');
  const selectedWishesValue = Array.from(selectedWishes).map((element) => element.value).join('%2C');
  const selectedPropertyTypes = document.querySelectorAll('input[name=property_type]:checked');
  const selectedPropertyTypesValue = Array.from(selectedPropertyTypes).map((element) => element.value).join('%2C');
  const selectedNeighborhoods = document.querySelectorAll('input[name=neighborhood]:checked');
  const selectedNeighborhoodsValue = Array.from(selectedNeighborhoods).map((element) => element.value).join('%2C');
  const selectedLocation = document.querySelector('input[name=location]:checked');
  const proximityInput = document.querySelector('input#proximity');
  const universe       = submitButton.dataset.universe;

  submitButtonUrl = `${window.location.href.replace(/\/+$/, '')}/`
  submitButtonUrlNbParams = 0

  if (universe === 'habitation') {
    submitButtonUrl += `${selectedWishesValue}/`
    submitButton.dataset.selectedWish = selectedWishesValue;
  } else if (universe === 'entreprise') {
    submitButtonUrl += `biens-immobiliers?_souhait_e=${selectedWishesValue}`
    submitButtonUrlNbParams++
    submitButton.dataset.selectedWish = selectedWishesValue;
  }
  if (selectedPropertyTypesValue) {
    if ( universe === 'entreprise' ) {
      propertyTypeSlug = 'type_e';
    } else if ( selectedWishesValue === 'acheter' ) {
      propertyTypeSlug = 'type_a';
    } else if ( selectedWishesValue === 'louer' ) {
      propertyTypeSlug = 'type_l';
    }
    submitButtonUrl += `${submitButtonUrlNbParams ? '&' : '?'}_${propertyTypeSlug}=${selectedPropertyTypesValue}`
    submitButtonUrlNbParams++
  }
  if (universe === 'habitation') {
    if (selectedLocation) {
      submitButtonUrl += `${submitButtonUrlNbParams ? '&' : '?'}_proximite=${selectedLocation.dataset.lat}%2C${selectedLocation.dataset.lng}%2C${proximityInput.value}%2C${selectedLocation.value}%252C%2520France`
      submitButtonUrlNbParams++
    }
  } else if (universe === 'entreprise') {
    if (selectedNeighborhoodsValue) {
      submitButtonUrl += `${submitButtonUrlNbParams ? '&' : '?'}_quartier=${selectedNeighborhoodsValue}`
      submitButtonUrlNbParams++
    }
  }
  if (submitButton.dataset.selectedWish !== '') {
    submitButton.removeEventListener('click', preventClick);
  }
  submitButton.href = submitButtonUrl;
}

function handleRangeChange(e) {
  let target = e.target
  if (e.target.type !== 'range') {
    target = document.getElementById('range')
  }
  const min = target.min
  const max = target.max
  const val = target.value
  const percentage = (val - min) * 100 / (max - min)
  target.style.backgroundSize = `${percentage}% 100%`

  const filterRadiusValue = target.parentNode.querySelector('.js-displayed-proximity');
  filterRadiusValue.textContent = val;
}

function preventClick(e) {
  e.preventDefault();
  const callout = presearch.querySelector('.callout');
  callout.classList.remove('hide');
}

function debounce(func, timeout = 250) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
